import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class TextAreaQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.TEXTAREA;

  constructor(options: any = {}) {
    super(options);
  }
}
